import { TrustedUserIcon } from "../Icon/TrustedUserIcon";
import React, { useState } from "react";
import { UserTrustBadgeType } from "./UserTrustBadge.types";
import { BOX_SHADOWS } from "../../Shared/styles";
import { Tooltip } from "@mui/material";
import { isDeviceOutputDesktop } from "../../../Domain/DeviceOutputState";
import { TooltipProps } from "@mui/material/Tooltip/Tooltip";
import {
    TOOLTIP_STATES,
    useSelfClosingTooltipStateHandler,
} from "../../../Infrastructure/Hooks/useTooltipStateHandler";
import { Box } from "@mui/system";

export const UserTrustBadge = function ({
    longTrustNote,
    isTrusted,
}: UserTrustBadgeType) {
    const [open, setOpen] = useState(false);
    const tooltipStateHandler = useSelfClosingTooltipStateHandler(setOpen);
    const isDesktopDeviceOutput = isDeviceOutputDesktop();
    if (!isTrusted) {
        return <></>;
    }

    const tooltipProps: TooltipProps = {
        componentsProps: {
            tooltip: {
                sx: {
                    marginTop: "0 !important",
                    ...BOX_SHADOWS.ELEVATION_3,
                    backgroundColor: "var(--community-color-snow-white)",
                    maxWidth: "none",
                    padding: "4px",
                    borderRadius: "4px",
                    fontSize: "14px",
                    fontWeight: 400,
                    color: "var(--community-color-primary-text)",
                },
            },
        },
        title: longTrustNote,
        children: (
            <Box
                onClick={(e) => {
                    e.stopPropagation();
                }}
                sx={{
                    display: "flex",
                }}
            >
                <Box
                    onPointerEnter={() => {
                        tooltipStateHandler(
                            TOOLTIP_STATES.OPEN,
                            0,
                            isDesktopDeviceOutput ? -1 : 1500
                        );
                    }}
                    onPointerLeave={() => {
                        isDesktopDeviceOutput &&
                            tooltipStateHandler(TOOLTIP_STATES.CLOSE);
                    }}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <TrustedUserIcon />
                </Box>
            </Box>
        ),
        open: open,
    };

    return <Tooltip {...tooltipProps} />;
};
